import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=7861f6da"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"
import style0 from "./MainLayout.vue?vue&type=style&index=0&id=7861f6da&prod&lang=css"
import style1 from "./MainLayout.vue?vue&type=style&index=1&id=7861f6da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports